export var single = [
    {
      "name": "Visits",
      "value": 0
    },
    {
      "name": "Event Organizers",
      "value": 0
    },
    {
      "name": "Events",
      "value": 0
    },
  ];


  // export var multi = [
  //   {
  //     "name": "Users",
  //     "series": [
  //       {
  //         "name": "2020-11-01",
  //         "value": 10
  //       },
  //       {
  //         "name": "2020-11-02",
  //         "value": 20
  //       }
  //     ]
  //   },
  //   {
  //     "name": "Visitors",
  //     "series": []
  //   },
  // ];
  

  export var topevents = [
    {
      "name": "Event 1",
      "value": null
    },
    {
      "name": "Event 2",
      "value": null
    },
    {
      "name": "Event 3",
      "value": null 
    },
    {
    "name": "Event 4",
    "value": null
  },
  {      "name": "Event 5",
  "value": null
}
  ];